import { getPartOfDay } from 'common/helpers/utils';

export default async function dashboardLoader() {
  return getPartOfDay();
}
